import MxIcons from "@rf-l1/MxIcons";
import { memo } from "react";
import SpainIcon from "@icons-rf/flags/spain-icon.svg?react";
import UniteState from "@icons-rf/flags/unite-state-icon.svg?react";
import { Grid, IconButton, styled } from "@mui/material";

const ButtonIdiom = styled(IconButton, {
  shouldForwardProp: prop => prop !== "active"
})<{ active: boolean }>(({ theme, active }) => ({
  borderColor: active ? theme.palette.primary.main : "transparent",
  borderStyle: "solid",
  borderWidth: 2,
  padding: 1,
  margin: 2,
  opacity: active ? 1 : 0.5,
  "&:hover": {
    backgroundColor: "transparent"
  },
  transition: "all 0.2s ease-in-out"
}));

interface MxButtonIdiomProps {
  idiom: "es" | "en";
  onClick: (idiom: "es" | "en") => void;
  availableIdioms?: {
    es: boolean;
    en: boolean;
  };
}

const MxButtonIdiom = memo(
  ({ idiom, onClick, availableIdioms }: MxButtonIdiomProps) => {
    const renderIdiomButton = (type: "es" | "en", Icon: typeof SpainIcon) => (
      <Grid item xs="auto">
        <ButtonIdiom
          active={idiom === type}
          size="small"
          onClick={() => onClick(type)}
        >
          <MxIcons size={20}>
            <Icon />
          </MxIcons>
        </ButtonIdiom>
      </Grid>
    );

    return (
      <Grid container>
        {availableIdioms?.es && renderIdiomButton("es", SpainIcon)}
        {availableIdioms?.en && renderIdiomButton("en", UniteState)}
      </Grid>
    );
  }
);

MxButtonIdiom.displayName = "MxButtonIdiom";

export default MxButtonIdiom;
